import { cn } from "@wags/ui/ui-utils";
import type { ReactNode } from "react";
import { DOG_CARD_PRESS_CLASS } from "@/components/shared/dogCardGrid";

export function GhostTileButton({
    headline,
    label,
    onClick,
}: {
    headline?: ReactNode;
    label: string;
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                "flex aspect-4/5 w-full flex-col items-center justify-center gap-2 bg-doberman-black/[0.04] px-4 text-center",
                DOG_CARD_PRESS_CLASS,

                "transition-[transform,background-color] [@media(hover:hover)]:hover:bg-doberman-black/[0.07]",
            )}
        >
            {headline && (
                <p className="font-family-body text-xl font-semibold leading-none text-doberman-black/70">
                    {headline}
                </p>
            )}
            <p className="text-body-small font-medium text-doberman-black/65">
                {label}
            </p>
        </button>
    );
}
